import React from 'react';
import { Book } from '@/components/Icons/Book';
import { tv } from '@/utils/tv';

const badge = tv({
  base: 'flex size-6 shrink-0 items-center justify-center rounded-full text-subhead-14',
  variants: {
    isPlaceholder: {
      true: 'bg-on-primary-surface text-subtle-foreground',
      false: 'bg-info-surface text-primary',
    },
  },
});

interface Props {
  lessonNumber?: number;
  isEmptyLesson?: boolean;
}

export const LessonNumberBadge: React.FC<Props> = ({
  lessonNumber,
  isEmptyLesson = false,
}) => (
  <span
    className={badge({
      isPlaceholder: lessonNumber === undefined || isEmptyLesson,
    })}
  >
    {lessonNumber ?? <Book className="size-4" />}
  </span>
);
